// src/routes/InvestorRoute.js
import PropTypes from "prop-types";
import React from "react";
import { Navigate } from "react-router-dom";
const InvestorRoute = ({ user, element, loadingUser }) => {
    if(loadingUser) return null;
    if(!user || user.role !== "investor")
        return <Navigate to="/unauthorized" />;
    // Prevent access if application_submitted is 0 or false
    if(!user.application_submitted || user.submitted === false) {
        return <Navigate to="/investor-account-creation" replace />;
    }
    return element;
};

InvestorRoute.propTypes = {
    user: PropTypes.shape({
        role: PropTypes.string,
        application_submitted: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.number,
        ]),
        submitted: PropTypes.bool,
    }),
    element: PropTypes.node.isRequired,
    loadingUser: PropTypes.bool,
};

export default InvestorRoute;
